import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { HandleRemoveHashTagRequest } from "./HandleRemoveHashTagRequest";

export function RemoveHashTagLink({ hashTag }: { hashTag: string }) {
    const linkText = `Remove ${hashTag}`;

    return (
        <div id="hashTagToRemoveLink" style={{ marginTop: `10px` }}>
            <IconWithText
                iconSuffix={EGlyphicon.trash}
                whenClicked={() => HandleRemoveHashTagRequest(hashTag)}
                displayAsBlock
            >
                {linkText}
            </IconWithText>
        </div>
    );
}
